function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.st0{fill:#241F21;}\r\n");

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M18.5,1h-17C1.224,1,1,1.224,1,1.5v17C1,18.776,1.224,19,1.5,19h17c0.276,0,0.5-0.224,0.5-0.5v-17 C19,1.224,18.776,1,18.5,1z M18,18H2V2h16V18z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M5.5,7h9C14.776,7,15,6.776,15,6.5S14.776,6,14.5,6h-9C5.224,6,5,6.224,5,6.5S5.224,7,5.5,7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M5.5,11h9c0.276,0,0.5-0.224,0.5-0.5S14.776,10,14.5,10h-9C5.224,10,5,10.224,5,10.5S5.224,11,5.5,11z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M5.5,15h9c0.276,0,0.5-0.224,0.5-0.5S14.776,14,14.5,14h-9C5.224,14,5,14.224,5,14.5S5.224,15,5.5,15z"
}));

function SvgModules(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModules);
export default __webpack_public_path__ + "static/media/modules.886423d6.svg";
export { ForwardRef as ReactComponent };